<script setup lang="ts">

import ConveyorTLBR from '@/components/Sections/Resources/Elements/Conveyor/ConveyorTLBR.vue'

import { defineProps, computed } from 'vue'
import type { PropType } from 'vue';
import type OreConversion from '@/types/OreConversion.ts'
import ConveyorTRBL from '@/components/Sections/Resources/Elements/Conveyor/ConveyorTRBL.vue'
import { usePlanetStore } from '@/stores/planetStore.ts'
import { CDN } from '@/models/cdn.ts'
import { useGameStore } from '@/stores/gameStore.ts'
import { useAssetStore } from '@/stores/assetStore.ts'

const planetStore = usePlanetStore()
const gameStore = useGameStore()
const assetStore = useAssetStore()

defineProps({
  left: {
    type: Number,
    required: true
  },
  top: {
    type: Number,
    required: true
  },
  height: {
    type: Number,
    required: true
  },
  width: {
    type: Number,
    required: true
  },
  ore: {
    type: Number,
    required: true
  },
  processed: {
    type: Object as PropType<OreConversion>,
    required: true
  },
  conveyorType: {
    type: String,
    required: false,
    default: 'left'
  },
  debug: {
    type: Boolean,
    required: false,
    default: false
  }
})

const dysonSwarmCount = computed(() => {
  return planetStore.countPlanetsBuildingDysonSwarm()
})

const hasDysonSwarmTech = computed(() => {
  const tech = assetStore.findTechByCode('dyson_swarm')
  return tech ? gameStore.hasPlayerTech(tech.id) : false
})

</script>

<template>
<div :class="{
          'absolute':true,
          'border':debug
        }"
     :style="'top:' + top + 'rem;left:' + left + 'rem;width:' + width + 'rem;height:' + height + 'rem;'">

  <!-- Left -->
  <ConveyorTLBR
    v-if="conveyorType == 'right'"
    :left="1.25"
    :top="1"
    :height="18"
    :width="3"
    :midTime="0.15"
    :min-speed="5"
    :object-image="CDN.icon('ore' + ore)"
    :conversion="processed"
    :debug="debug"
  />

  <!-- Right -->
  <ConveyorTRBL
    v-else-if="conveyorType == 'left'"
    :left="3.5"
    :top="1"
    :height="18"
    :width="4"
    :midTime="0.15"
    :min-speed="5"
    :object-image="CDN.icon('ore' + ore)"
    :conversion="processed"
    :debug="debug"
  />



  <div :class="{
            'absolute rounded bg-slate-800 border':true,
            'border-slate-700 hover:border-slate-600': hasDysonSwarmTech,
            'border-slate-800 cursor-not-allowed': !hasDysonSwarmTech,
            'opacity-50':debug
          }"
       style="top:18rem;left:0rem;width:8rem;z-index:15"
  >
    <div class="flex-col pb-1">
      <img
        :class="{
          'mx-auto p-1' : true,
          'grayscale': !hasDysonSwarmTech
        }"
        :src="CDN.building(128,'dyson_sphere_construction_facility')"
        alt="Dyson Swarm Technology">
      <div class="text-center text-green-500" v-if="dysonSwarmCount > 0 && hasDysonSwarmTech">{{ dysonSwarmCount }} Planets Building a Dyson
        Swarm</div>
      <div class="text-center text-red-500" v-else-if="!hasDysonSwarmTech">Dyson Swarm Technology Required</div>
      <div class="text-center" v-else>No Dyson Swarm Construction</div>
    </div>
  </div>

</div>
</template>

<style scoped lang="scss">

</style>